import { fetchApi } from '@/config/axiosSetting';
import {
  GetOwnerInformationQueryParamsType,
  GetOwnerInformationQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQuery.type';

export const getInitialVisitOwnerInformationQueryFunction = (
  params: GetOwnerInformationQueryParamsType,
): Promise<GetOwnerInformationQueryResponseType> => {
  return fetchApi.get(`initial/reports/${params.id}/insurer_information/`, {
    params,
  });
};
